import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServerConfig } from '../../../../services/server-config.model';
import { Observable } from 'rxjs';
import { ServerConfigService } from '../../../../services/server-config.service';

@Component({
    selector: 'lex-server-config-item',
    templateUrl: './server-config-item.component.html',
    styleUrls: ['./server-config-item.component.scss'],
    standalone: false
})
export class ServerConfigItemComponent implements OnInit {

  @Input() config: ServerConfig;
  @Input() actionNotifier: Observable<boolean>;
  @Output() valueChange = new EventEmitter<void>();

  originalValue: string;

  constructor(private service: ServerConfigService) { }

  ngOnInit(): void {
    this.actionNotifier.subscribe(next => {if (next) this.save(); else this.cancel();})
    this.originalValue = this.config.value;
  }

  save() {
    if (this.config.value !== this.originalValue)
      this.service.updateServerConfig(this.config).subscribe(
        () => this.originalValue = this.config.value,() => this.markDirty()
      );
  }

  cancel() {
    this.config.value = this.originalValue;
  }

  markDirty() {
    this.valueChange.emit();
  }
}
